import React from "react";
import { getMobileCardTemplates } from "../common/common";
import { Droppable } from "react-beautiful-dnd";
import { DragWrapper } from "../common/dnd";

const MobileFieldsPanel: React.FunctionComponent<{}> = (props) => {

    let sections = getMobileCardTemplates()
    console.log('mobile-widget-templates ', sections);

    return <div className='wd-field-panel'>
        <div className="not-selected">Drag and drop an item to highlighted are and click on it to configure the properties</div>

        <Droppable droppableId="fields" isDropDisabled={true}  >
            {
                (provided, snapshot) => {
                    return <div className='wd-field-panel-field-list' ref={provided.innerRef}>
                        {
                            sections.map((f, index) => {
                                return <MobileFieldWrapper field={f} index={index} />
                            })
                        }
                        {provided.placeholder}
                    </div>
                }
            }
        </Droppable>
    </div>
}

const MobileFieldWrapper: React.FunctionComponent<{ field: any, index: number }> = (props) => {
    return (

        <DragWrapper type='mobileField' data={props.field} index={props.index}>
            {
                (provided, snapshot) => {
                    return <><div className='wd-field-item' {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef} >
                        <div className='wd-field-title'>{props.field.id}</div>
                        <div className='wd-field-description'>{props.field.description}</div>
                    </div>
                        {
                            snapshot.isDragging && <div className='wd-field-item' >
                                <div className='wd-field-title'>{props.field.id}</div>
                                <div className='wd-field-description'>{props.field.description}</div>
                            </div>
                        }
                    </>;
                }
            }

        </DragWrapper>

    )
};


export default MobileFieldsPanel